import {Injectable, Inject, PLATFORM_ID, inject} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DeviceDetectorService } from 'ngx-device-detector';

//import {Tools_aiConsoleService} from "@llm/service/tools_ai-console.service";


@Injectable({
  providedIn: 'root'
})
export class NavigatorDeviceDetectorService {
  //Injectbales
  //private _console = inject(Tools_aiConsoleService);

  constructor(private deviceDetector: DeviceDetectorService) {
  }

  /**
   * Obtiene información completa del dispositivo
   * @returns {{
   *   device: 'mobile' | 'tablet' | 'desktop';
   *   browser: string;
   *   os: string;
   * }}
   */
  public getDeviceInfo() {
    return {
      device: this.getDeviceType(),
      browser: this.deviceDetector.browser,
      os: this.deviceDetector.os
    };
  }

  /**
   * Determina el tipo de dispositivo
   * @returns {'mobile' | 'tablet' | 'desktop'}
   */
  private getDeviceType(): 'mobile' | 'tablet' | 'desktop' {
    if (this.deviceDetector.isMobile()) return 'mobile';
    if (this.deviceDetector.isTablet()) return 'tablet';
    return 'desktop';
  }

  // Métodos directos para acceso rápido
  isMobile(): boolean {
    return this.deviceDetector.isMobile();
  }

  isTablet(): boolean {
    return this.deviceDetector.isTablet();
  }

  isDesktop(): boolean {
    return this.deviceDetector.isDesktop();
  }

  getBrowserName(): string {
    return this.deviceDetector.browser;
  }

  getOS(): string {
    return this.deviceDetector.os;
  }

  /**
   * Verifica si el navegador es uno de los especificados
   * @param browsers Navegadores a comprobar (ej: ['chrome', 'firefox'])
   */
  isBrowser(browsers: string[]): boolean {
    return browsers.includes(this.getBrowserName().toLowerCase());
  }

  /**
   * Verifica si el sistema operativo es uno de los especificados
   * @param systems Sistemas operativos a comprobar (ej: ['windows', 'mac'])
   */
  isOS(systems: string[]): boolean {
    return systems.includes(this.getOS().toLowerCase());
  }

    getBrowserVersion(): string {
        const userAgent = navigator.userAgent;
        const browser = this.getBrowserName().toLowerCase();

        let version = 'unknown';

        try {
            switch (browser) {
                case 'chrome':
                    version = userAgent.match(/Chrome\/([0-9.]+)/)?.[1] || 'unknown';
                    break;
                case 'firefox':
                    version = userAgent.match(/Firefox\/([0-9.]+)/)?.[1] || 'unknown';
                    break;
                case 'safari':
                    version = userAgent.match(/Version\/([0-9.]+)/)?.[1] || 'unknown';
                    break;
                case 'edge':
                    version = userAgent.match(/Edg\/([0-9.]+)/)?.[1] || 'unknown';
                    break;
                case 'opera':
                    version = userAgent.match(/OPR\/([0-9.]+)/)?.[1] || 'unknown';
                    break;
                default:
                    // fallback genérico
                    const genericMatch = userAgent.match(/([a-zA-Z]+)\/([0-9.]+)/);
                    version = genericMatch ? genericMatch[2] : 'unknown';
                    break;
            }
        } catch (e) {
            version = 'unknown';
        }

        return version;
    }

}
